<template>
  <div>
    <input class="form-control mb-2 mr-sm-2" type="tel" id="example-phone-input"
           v-model="data.phone" disabled="true"
           required>
  </div>
</template>

<script>
// import {mapGetters} from "vuex";

export default {
  name: "phoneColumn",
  props: {
    data: {
      type: Object,
      required: true,
    }
  },

  // methods: {
  //   isWorker() {
  //     if (this.data.disabled) {
  //       return true;
  //     } else {
  //       return !this.isAvailable(['admin']);
  //     }

  //   },
  //   isAvailable(roles) {
  //     return this.meRoles.map(item => roles.includes(item)).includes(true)
  //   }
  // },
  // computed: {
  //   ...mapGetters(['meRoles'])
  // },
}
</script>

<style scoped>
  .form-control {
    width: 140px;
  }
</style>
